<ng-container *ngIf="props; else loading">

    <div class="card-info" (click)="handleClick(props)">
        <mat-icon (click)="close($event)" class="close-btn" alt="cerrar">close</mat-icon>

        <div class="container-message">
            <div class="card-icon">
                <sit-icon [icon]="Icon.alert_y" [sizeClass]="'icon-size-56'" class="d-flex"></sit-icon>
            </div>

            <div class="card-body">
                <h5>Alerta videoanalítica</h5>
                <div class="footer-info">
                    <div class="d-flex gap-8-px align-items-center">
                        <sit-icon [icon]="Icon.calendar_y" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                        <span>{{ props?.date | date:'dd/MM/yyyy - hh:mm' }}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>


</ng-container>

<ng-template #loading>
    <sit-spinner />
</ng-template>
